import PropTypes from 'prop-types';

const Capitalize = ({ string = '' }) =>
  string ? string.charAt(0).toUpperCase() + string.slice(1) : null;

Capitalize.propTypes = {
  string: PropTypes.string
};

export { Capitalize };
